import { useWhitelabelContext } from 'context/whitelabel.context';
import React from 'react';
import styled from 'styled-components';

const OpenFilterButton = ({ total, handleClick }) => {
  const { lookAndFeel } = useWhitelabelContext();
  return (
    <CustomizedOpenFilter
      bg={lookAndFeel.button.bg_color}
      textColor={lookAndFeel.button.text_color}
      className="category-filter-mobile d-lg-none d-flex"
      onClick={() => handleClick()}
    >
      <img src="/global/filter.svg" alt="image" className="me-3"></img>
      <span>Filter Course ({total})</span>
    </CustomizedOpenFilter>
  );
};

export default OpenFilterButton;

const CustomizedOpenFilter = styled.div`
  background: ${({ bg }) => (bg ? `${bg} !important` : '')};
  color: ${({ textColor }) => (textColor ? `${textColor} !important` : '')};
`;
